module.exports = __webpack_public_path__ + "static/media/burlingame8.4920384a.jpg";